import type { AcfSectionWithSidebarItem } from '@typings'
import { RaButton, RaIcon, RaImage, RaRichText } from '@components/core/index.core'
import { ICONS } from '@constants/icons.constants'

import styles from './ra-sidebar-component.module.scss'

export const RaSidebarComponent = ({ sidebar }: AcfSectionWithSidebarItem) => {
  const pretty = {
    phonenumber: sidebar?.contact.replace(/\(0\)\s*/, '').replace(/\s+/g, ''),
  }

  return (
    <div className={styles['sidebar']}>
      {sidebar.contact && (
        <RaButton
          fullWidth
          label={sidebar.contact}
          link={{
            url: `tel:${pretty.phonenumber}`,
            title: 'Contact',
            target: '_blank',
          }}
          startIcon={
            <RaIcon
              icon={ICONS.MOBILE}
              color="light"
            />
          }
        />
      )}
      {sidebar.image && (
        <RaImage
          image={sidebar.image}
          rotate="right"
          elevation="light"
        />
      )}
      {sidebar.content && <RaRichText content={sidebar.content} />}
    </div>
  )
}
